import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'
import { ProfileViewType } from '__utils/type';
export interface KycComplianceState {

    getProfileViewError: any;
    profileView?: ProfileViewType;
    nameInHeader? :string;
    profileViewError?: any;
}
const rawState: KycComplianceState = {
    getProfileViewError: "",
};

const intialState = fromJS(rawState);

export default function profileViewReducer (
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type)
    {
        case Actions.FETCH_GET_PROFILE_VIEW_SUCCESS:
            return merge(state, fromJS({ profileView: action.payload.data }));

        case Actions.FETCH_GET_PROFILE_VIEW_FAILURE:
            return merge(state, fromJS({ getProfileViewError: action.payload.data, profileView: null }));

        case Actions.SET_NAME_IN_HEADER:
            return merge(state, fromJS({ nameInHeader: action.payload }));

        case Actions.UPDATE_PROFILE_VIEW_ERROR:
            return merge(state, fromJS({ profileViewError: action.payload.data }));

        default:
            return state;
    }
}
